
import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@uplight/up-design-components/components/Alert';
import { Tenants } from '../../../server/micrositeConstants';

// Custom per-tenant sub-components for EHERS Enrollment microsite go here.

export const Step1CTA1 = ({ hostId }) => {
  if (hostId === Tenants.ALABAMA_POWER_CO) {
    return (
      <>
        <p style={{ marginTop: '7%' }}>
          Learn more about how your home uses energy with our Electronic Home Energy Reports
          (eHERs). Each month, you&#39;ll get an emailed report
          that shows you how your home&#39;s energy
          use changes over time, gives you insights to what&#39;s using
          energy most and offers tips to
          help you save energy and money.
        </p>
        <p>
          Sign up now to get your free monthly report!
        </p>
      </>
    );
  }

  return 'Learn More';
};

Step1CTA1.propTypes = {
  hostId: PropTypes.string.isRequired,
};

export const Step1IneligibleMessage = ({ hostId, onClose }) => {
  if (hostId === Tenants.ALABAMA_POWER_CO) {
    return (
      <Alert icon={false} severity="error" onClose={onClose}>
        <span style={{ color: 'var(--dark-red-color)' }}>You are currently not eligible. Contact us at 1-800-990-2726 for further assistance.</span>
      </Alert>
    );
  }

  return (<Alert icon={false} severity="error" onClose={onClose}>There was an error checking your eligibility. Please try again later.</Alert>);
};
Step1IneligibleMessage.propTypes = {
  hostId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export const Step2CTA1 = ({ hostId }) => {
  if (hostId === Tenants.ALABAMA_POWER_CO) {
    return (
      <>
        <p style={{ marginTop: '7%' }}>
          Want to learn more about your electric bill? Electronic Home Energy Reports,
          or eHERs, can help you see how your home uses energy.
        </p>
        <p>
          Complete your enrollment now, and each month you will get an email with a report.
          It will show you what uses the most energy and give you tips
          on how to save energy and money.
        </p>
      </>
    );
  }

  return 'Learn More2';
};

Step2CTA1.propTypes = {
  hostId: PropTypes.string.isRequired,
};

export const Step2LearnMore = ({ hostId }) => {
  if (hostId === Tenants.ALABAMA_POWER_CO) {
    return (
      <>
        <div id="right-container" className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
          <p className="main-header">
            Be Informed,
            <br />
            Take Action.
          </p>
          <p className="point">Get free reports at your fingertips</p>
          <p className="point">See estimates for how your home uses energy, divided into categories</p>
          <p className="point">Compare how your energy use changes over time</p>
          <p className="point">Get tips to help you save energy</p>
        </div>
      </>
    );
  }

  return 'Learn More';
};

Step2LearnMore.propTypes = {
  hostId: PropTypes.string.isRequired,
};

export const TermsAndConditionsText = ({ hostId, currentYear }) => {
  if (hostId === Tenants.ALABAMA_POWER_CO) {
    return (
      <>
        <p>
          Participation in the eHERS program is limited to residential
          Alabama Power customers who are pre-qualified based on specific rate and meter data.
          You can withdraw from the program at any time. For questions, please contact our
          Products & Services Team at 1-800-990-2726 (APCO) or email us at
          productssolutions@alabamapower.com, Monday through Friday, 8:00 AM - 5:00 PM Central.
        </p>
        <p>
          &copy;
          {currentYear}
          {' '}
          Alabama Power Company. All rights reserved.
        </p>
      </>
    );
  }
  return (
    <>
      &copy;
      {currentYear}
      {' '}
      All rights reserved.
    </>
  );
};

TermsAndConditionsText.propTypes = {
  hostId: PropTypes.string.isRequired,
  currentYear: PropTypes.number.isRequired,
};


export const Step2BoxRow = ({ hostId, assetsMicrositeDir }) => {
  if (hostId === Tenants.ALABAMA_POWER_CO) {
    return (
      <div className="row benefits-row">
        <div className="benefit-box">
          <p>Know Your Power</p>
          <img src={`${assetsMicrositeDir}/SmartThermostat.jpg`} alt="Smart Thermostat" />
          <p className="subheading">Understand your energy use and ways to optimize year-round.</p>
        </div>
        <div className="benefit-box">
          <p>Smarter Living</p>
          <img src={`${assetsMicrositeDir}/SmartHome.jpg`} alt="Smart Home" />
          <p className="subheading">Receive energy efficiency tips and program recommendations for your home.</p>
        </div>
        <div className="benefit-box">
          <p>Keep It Convenient</p>
          <img src={`${assetsMicrositeDir}/SmartphoneRinging.jpg`} alt="Smart Phone" />
          <p className="subheading">Revisit your report anytime, anywhere, from your mobile device.</p>
        </div>
      </div>
    );
  }

  return 'Step2BoxRow';
};
Step2BoxRow.propTypes = {
  hostId: PropTypes.string.isRequired,
  assetsMicrositeDir: PropTypes.string.isRequired,
};


export const Step2EnrollmentErrorMessage = ({ hostId, onClose }) => {
  if (hostId === Tenants.ALABAMA_POWER_CO) {
    return (
      <Alert icon={false} severity="error" onClose={onClose}>
        <span style={{ color: 'var(--dark-red-color)' }}>There was an error with your enrollment. Please try again in a few minutes. You can also contact us at 1-800-990-2726 for further assistance.</span>
      </Alert>
    );
  }

  return (<Alert icon={false} severity="error" onClose={onClose}>There was an error with your enrollment. Please try again later.</Alert>);
};
Step2EnrollmentErrorMessage.propTypes = {
  hostId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};
